import Request from 'modules/request';
import { requireShopSystem } from '../../../declarations/runtimeExports';

const shopSystem = requireShopSystem();

export interface SubmitItem {
    block?: string;
    blockLabel?: string;
    label?: string;
    url?: string;
    value?: string;
}

export class SearchFormSubmitService {
    private static followUrl(item: SubmitItem, searchField: HTMLInputElement): void {
        shopSystem.appendSpecificItemsToForm(item, shopSystem.getFormFromInput(searchField), 'result_v3');
        const request = new Request({
            timeout: 1000,
            onComplete: () => {
                shopSystem.followUrl(item.url);
            },
        });
        request.send('search', {});
    }
    public static submit(item: SubmitItem, searchField: HTMLInputElement): void {
        shopSystem.setSearchFieldElement(searchField);

        if (item.url) {
            this.followUrl(item, searchField);
        } else {
            this.submitAttribute(item, searchField);
        }
    }

    public static submitAttribute(item: SubmitItem, searchField: HTMLInputElement): void {
        shopSystem.appendItemsAndSubmitForm(item, shopSystem.getFormFromInput(searchField), 'result_v3');
    }
}
